import React from 'react'

import LetterLanding from '../LetterLanding';

import logo_target from '../../../images/letterfunnel/codeforgood.webp';
import screenshot_target from '../../../images/letterfunnel/koenlooijmans.webp';


export default class extends React.Component {

  // variable "competition" is optional, fallback: "jouw B2B concurrenten".
  render() {
    return <LetterLanding
      fullname="Koen Looijmans"
      firstname="Koen"
      companyname="Code for Good"
      competition="VBTI en ViNotion"
      logo_target={logo_target}
      screenshot_target={screenshot_target}
    />;
  }

}



// WEBPACK FOOTER //
// ./src/containers/letterfunnel/landings/koenlooijmans.js